import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "car-card group rounded-2xl border border-slate-200 bg-white p-5 md:p-6 shadow-sm hover:shadow-md transition" }
const _hoisted_2 = { class: "grid grid-cols-1 gap-6 md:grid-cols-[minmax(240px,340px),1fr,auto] items-start" }
const _hoisted_3 = { class: "w-full flex items-center justify-center bg-slate-50/50 rounded-xl overflow-hidden h-[140px] max-h-[160px]" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex flex-col gap-4" }
const _hoisted_6 = { class: "flex flex-col md:flex-row md:items-center md:justify-between gap-1" }
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "text-xl font-bold text-slate-900 leading-tight" }
const _hoisted_9 = {
  key: 0,
  class: "text-sm font-medium text-slate-500 uppercase tracking-wide"
}
const _hoisted_10 = {
  key: 0,
  class: "text-right"
}
const _hoisted_11 = {
  key: 0,
  class: "text-lg font-bold text-slate-900 flex items-center gap-2"
}
const _hoisted_12 = {
  key: 1,
  class: "text-lg font-bold text-slate-900"
}
const _hoisted_13 = {
  key: 2,
  class: "mt-0.5 text-xs text-slate-500"
}
const _hoisted_14 = { class: "font-semibold" }
const _hoisted_15 = {
  key: 3,
  class: "text-[13px] text-slate-700"
}
const _hoisted_16 = { class: "font-semibold" }
const _hoisted_17 = {
  key: 1,
  class: "inline-flex w-max items-center rounded-full border border-amber-300 bg-amber-50 px-2.5 py-1 text-xs font-semibold text-amber-800"
}
const _hoisted_18 = { class: "flex flex-wrap items-center gap-4 text-sm text-slate-600" }
const _hoisted_19 = { class: "inline-flex items-center gap-2" }
const _hoisted_20 = { class: "inline-flex h-7 min-w-[32px] items-center justify-center rounded-full border border-slate-200 px-2" }
const _hoisted_21 = { class: "inline-flex items-center gap-2" }
const _hoisted_22 = { class: "inline-flex h-7 min-w-[32px] items-center justify-center rounded-full border border-slate-200 px-2" }
const _hoisted_23 = {
  key: 0,
  class: "inline-flex items-center gap-2"
}
const _hoisted_24 = { class: "inline-flex h-7 min-w-[32px] items-center justify-center rounded-full border border-slate-200 px-2" }
const _hoisted_25 = {
  key: 0,
  class: "mt-1 md:mt-0"
}
const _hoisted_26 = {
  key: 0,
  class: "inline-flex w-full items-center justify-center gap-2 rounded-full border-2 border-emerald-600 bg-emerald-600 px-6 py-2.5 text-sm font-semibold text-white md:w-auto",
  disabled: ""
}
const _hoisted_27 = { class: "mt-5 flex items-center justify-between border-t border-slate-200 pt-4" }
const _hoisted_28 = { class: "grid h-7 w-7 place-items-center rounded-full border border-slate-200 bg-white transition group-hover:bg-slate-100" }
const _hoisted_29 = { class: "mt-4 rounded-xl bg-slate-50 p-4" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = { class: "mt-4 grid grid-cols-1 gap-3 rounded-lg bg-white p-4 ring-1 ring-slate-200" }
const _hoisted_32 = {
  key: 0,
  class: "mt-2 pt-2 border-t border-slate-100 flex flex-col gap-2"
}
const _hoisted_33 = {
  key: 0,
  class: "flex items-center gap-3"
}
const _hoisted_34 = { class: "ml-auto text-sm text-slate-700 font-medium" }
const _hoisted_35 = {
  key: 1,
  class: "flex items-center gap-3"
}
const _hoisted_36 = { class: "ml-auto text-sm text-slate-700 font-medium" }

import { computed, ref } from 'vue'
import { Car as CarData, UserSearch } from '@/types'
import { retrieveUserSearch } from '@/services/search-service'
import { getHoursPerDay } from '@/utils/common'
import { calculateCarPrice } from '@/utils/pricing'

// Category images mapping
import sClassImg from '@/assets/cars/luxury-sedan.png'
import vClassImg from '@/assets/cars/van.png'
import eClassImg from '@/assets/cars/premium-sedan.png'
import gmcSuvImg from '@/assets/cars/suv.png'


export default /*@__PURE__*/_defineComponent({
  __name: 'CarResult',
  props: {
    canSelect: { type: Boolean },
    car: {},
    selectedCar: {},
    isLead: {},
    kmDistance: {}
  },
  emits: ["selected"],
  setup(__props: any, { emit: __emit }) {

const getCategoryImage = (typeName: string) => {
  const name = (typeName || '').toLowerCase()
  if (name.includes('premium')) return eClassImg
  if (name.includes('luxury')) return sClassImg
  if (name.includes('van')) return vClassImg
  if (name.includes('suv')) return gmcSuvImg
  if (name.includes('bus')) return '/assets/busescoaches.jpeg'
  if (name.includes('boat')) return '/assets/nocarfound.jpeg'
  if (name.includes('standard')) return eClassImg
  
  return '/assets/nocarfound.jpeg'
}

const props = __props

const emit = __emit

const userSearch = ref<UserSearch>(retrieveUserSearch())
const expanded = ref(false)

// hours → days (for hourly)
const hoursPerDay = getHoursPerDay()
const days = computed(() => {
  const h = Number(userSearch.value?.hours ?? 0)
  return h > 0 ? h / (hoursPerDay || 10) : 0
})
const daysLabel = computed(() => {
  let label = `${days.value}`.replace('.0', '') + ' day(s)'
  const locHours = props.car?.chaufferLocation?.hours_per_day
  const supplierHours = props.car?.supplier?.hours
  const locKm = props.car?.chaufferLocation?.km_per_day
  
  const finalH = (locHours && Number(locHours) > 0) ? locHours : supplierHours
  
  if (finalH && Number(finalH) > 0) {
    label += ` (${Number(finalH).toFixed(0)} hrs`
    if (locKm && Number(locKm) > 0) {
      label += ` & ${Number(locKm).toFixed(0)} km`
    }
    label += `)`
  }
  return label
})

// ===== Pricing-calculated car snapshot (keeps your original rules) =====
const carr = computed(() => {
  const pricing = calculateCarPrice(props.car, userSearch.value, props.kmDistance)
  return {
    ...(props.car || {}),
    ...pricing
  }
})

// Extra Charges Calculation
const extraKmPrice = computed(() => {
  let charge = parseFloat(props.car?.chaufferLocation?.extra_km_charge || props.car?.transferLocation?.extra_km_charge || '0')
  if (charge > 0 && props.car?.priceFactor > 0) {
    charge = charge / ((100 - props.car.priceFactor) / 100)
  }
  return charge
})

const extraHrPrice = computed(() => {
  let charge = parseFloat(props.car?.chaufferLocation?.extra_hr_charge || props.car?.transferLocation?.extra_hr_charge || '0')
  if (charge > 0 && props.car?.priceFactor > 0) {
    charge = charge / ((100 - props.car.priceFactor) / 100)
  }
  return charge
})

const hasPrice = computed(() => Number(carr.value?.price || 0) > 0)
const formattedTotal = computed(() => {
  const v = Number(carr.value?.price || 0)
  return v ? `$${v.toFixed(2)}` : ''
})
const formattedDaily = computed(() => {
  const v = Number(carr.value?.dailyrate || 0)
  return v ? `$${v.toFixed(2)}` : '$0.00'
})

const handleSelectCar = (car: CarData) => {
  emit('selected', car)
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "w-full h-full object-contain p-2",
          src: carr.value.image && carr.value.image !== '' && !carr.value.image.includes('default.jpg') ? carr.value.image : getCategoryImage(carr.value.type?.name),
          alt: "Vehicle image"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h3", _hoisted_8, _toDisplayString((Number(carr.value?.price || 0) <= 0 || (_ctx.isLead && _ctx.isLead == '1')) ? (carr.value?.type?.name || carr.value?.name) : carr.value?.name), 1),
            (Number(carr.value?.price || 0) > 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(carr.value?.type?.name), 1))
              : _createCommentVNode("", true)
          ]),
          (hasPrice.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (carr.value.isCalculating)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[2] || (_cache[2] = [
                      _createElementVNode("span", { class: "text-sm font-normal animate-pulse" }, "Calculating Price...", -1)
                    ])))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(formattedTotal.value), 1)),
                (userSearch.value.type === 'hourly')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _cache[3] || (_cache[3] = _createTextVNode(" Price for ")),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(daysLabel.value), 1)
                    ]))
                  : _createCommentVNode("", true),
                (userSearch.value.type === 'hourly')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "font-medium" }, "Daily rate:", -1)),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(formattedDaily.value), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_17, " On request "))
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "font-icon theme-icon users-icon text-[22px] md:text-[22px] text-slate-800 leading-none" }, null, -1)),
            _createElementVNode("span", _hoisted_20, _toDisplayString(carr.value?.type?.passengers ?? '—'), 1),
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "sr-only" }, "Passengers", -1))
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "font-icon theme-icon suitcase-icon text-[22px] md:text-[22px] text-slate-800 leading-none" }, null, -1)),
            _createElementVNode("span", _hoisted_22, _toDisplayString(carr.value?.type?.bags ?? '—'), 1),
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "sr-only" }, "Bags", -1))
          ]),
          (carr.value?.type?.doors != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-[18px]" }, "🚪", -1)),
                _createElementVNode("span", _hoisted_24, _toDisplayString(carr.value?.type?.doors ?? '—'), 1),
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "sr-only" }, "Doors", -1))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.canSelect)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            (_ctx.selectedCar && carr.value && _ctx.selectedCar.id === carr.value.id)
              ? (_openBlock(), _createElementBlock("button", _hoisted_26, [
                  _cache[11] || (_cache[11] = _createTextVNode(" Select ")),
                  _createVNode(_component_font_awesome_icon, {
                    size: "lg",
                    icon: "fa-solid fa-check",
                    class: "text-white"
                  })
                ]))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (handleSelectCar(carr.value))),
                  class: "inline-flex w-full items-center justify-center rounded-full border-2 border-slate-900 bg-slate-900 px-6 py-2.5 text-sm font-semibold text-white transition hover:bg-white hover:text-slate-900 md:w-auto"
                }, " Select "))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (expanded.value = !expanded.value)),
        class: "inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-slate-600 hover:text-slate-900"
      }, [
        _createElementVNode("span", _hoisted_28, [
          _createVNode(_component_font_awesome_icon, {
            size: "xs",
            icon: "fa-solid fa-chevron-down",
            class: _normalizeClass(["transition", expanded.value ? 'rotate-180 text-slate-900' : 'text-slate-600'])
          }, null, 8, ["class"])
        ]),
        _cache[12] || (_cache[12] = _createTextVNode(" More info "))
      ]),
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-xs text-slate-500" }, [
        _createTextVNode(" Free cancellation up to "),
        _createElementVNode("span", { class: "font-medium" }, "72h before pickup")
      ], -1))
    ]),
    _createVNode(_Transition, { name: "fade-slide" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", {
            class: "text-[15px] leading-relaxed text-slate-700",
            innerHTML: (carr.value?.type?.description || '').replace(/\n/g, '<br>')
          }, null, 8, _hoisted_30),
          _createElementVNode("div", _hoisted_31, [
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "flex items-center gap-3" }, [
              _createElementVNode("div", { class: "text-xs font-semibold uppercase tracking-wide text-slate-500" }, "Cancellation"),
              _createElementVNode("div", { class: "ml-auto text-sm text-slate-700 text-right" }, " Free cancellation up to 72 hours before pickup ")
            ], -1)),
            (extraKmPrice.value > 0 || extraHrPrice.value > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  (extraKmPrice.value > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-xs font-semibold uppercase tracking-wide text-slate-500" }, "Extra KM", -1)),
                        _createElementVNode("div", _hoisted_34, " $" + _toDisplayString(extraKmPrice.value.toFixed(2)) + " per km ", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (extraHrPrice.value > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "text-xs font-semibold uppercase tracking-wide text-slate-500" }, "Extra Hour", -1)),
                        _createElementVNode("div", _hoisted_36, " $" + _toDisplayString(extraHrPrice.value.toFixed(2)) + " per hour ", 1)
                      ]))
                    : _createCommentVNode("", true),
                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-[11px] text-slate-400 italic" }, " * Additional charges will be collected at the end of service if limits are exceeded. ", -1))
                ]))
              : _createCommentVNode("", true)
          ])
        ], 512), [
          [_vShow, expanded.value]
        ])
      ]),
      _: 1
    })
  ]))
}
}

})